import { render, staticRenderFns } from "./ExportButton.vue?vue&type=template&id=4863be5d&"
import script from "./ExportButton.vue?vue&type=script&lang=ts&"
export * from "./ExportButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports